import Image from '@base/Image';
import styled from '@emotion/styled';
import UserAwardLeftIcon from '@icon/Referrals/userAwardLeftIcon';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import styleHelper from '@utils/styleHelper';
import Typography from 'aquilla/core/atoms/Typography';

const Container = styled.div<{ $bgColor: string }>`
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
  background-color: ${({ $bgColor }) => $bgColor};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_3B};
  }
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_3B};
`;

const UserImageWrapper = styled.div`
  width: ${Spacings.SPACING_9B};
  height: ${Spacings.SPACING_9B};
  position: relative;
  border-radius: ${Spacings.SPACING_18B};
  & > span {
    border-radius: 100%;
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_2};
`;

const Title = styled(Typography)`
  line-height: ${Spacings.SPACING_18};
`;

const SubTitle = styled(Typography)`
  color: var(--color-text-secondary);
`;

const RightWrapper = styled.div`
  height: 24px;
  display: flex;
  flex-direction: row;
`;

const AwardLeftRightIconWrapper = styled.div<{ $flip: boolean }>`
  height: ${Spacings.SPACING_6B};
  width: 14px;
  position: relative;
  margin-right: -1px;
  margin-left: -1px;
  display: flex;
  transform: ${({ $flip }) => ($flip ? 'scaleX(-1)' : '')};
`;

const Amount = styled.div<{ $backgroundColor: string; $color: string }>`
  display: flex;
  align-items: center;
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.H7};
  line-height: ${Fonts.BUTTON_LINE_HEIGHT};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $color }) => $color};
`;

const UserAwardedCard = ({
  cardData,
  id = 'list-data',
  color = '#8B8B8B',
  bgColor = ''
}) => {
  const {
    referralCount,
    rewardsWon,
    currentUserData,
    userData: { avatar = '', firstName = '' } = {}
  } = cardData ?? {};

  const bgLightColor = styleHelper.hexToRgb(color, 0.08);
  const getAwardleftRightIcon = ({ flip }) => {
    return (
      <AwardLeftRightIconWrapper $flip={flip}>
        <UserAwardLeftIcon color={color} width={14} height={24} />
      </AwardLeftRightIconWrapper>
    );
  };

  if (!cardData || !Object.keys(cardData)?.length) return null;

  return (
    <Container id={id} $bgColor={bgColor}>
      <LeftWrapper>
        <UserImageWrapper>
          <Image src={avatar} alt="User Avatar" layout="fill" />
        </UserImageWrapper>
        <InfoWrapper>
          <Title variant="h6">{currentUserData ? 'You' : firstName}</Title>
          <SubTitle variant="p3">
            {currentUserData && referralCount === 0
              ? 'Refer & enter the hall of fame'
              : `${referralCount} referrals`}
          </SubTitle>
        </InfoWrapper>
      </LeftWrapper>
      <RightWrapper>
        {getAwardleftRightIcon({ flip: false })}
        <Amount $backgroundColor={bgLightColor} $color={color}>
          {rewardsWon ? `₹${rewardsWon}` : '-'}
        </Amount>
        {getAwardleftRightIcon({ flip: true })}
      </RightWrapper>
    </Container>
  );
};

export default UserAwardedCard;
